import { render, staticRenderFns } from "./dosyamenu.vue?vue&type=template&id=25990204&scoped=true&"
import script from "./dosyamenu.vue?vue&type=script&lang=js&"
export * from "./dosyamenu.vue?vue&type=script&lang=js&"
import style0 from "./dosyamenu.vue?vue&type=style&index=0&id=25990204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25990204",
  null
  
)

export default component.exports